import { gql } from 'apollo-boost'

const GET_ANNI = gql`
  query anniBollette {
    anniBollette
  }
`

export default GET_ANNI